import '../../assets/index21.css';var oe = Object.defineProperty, le = Object.defineProperties;
var te = Object.getOwnPropertyDescriptors;
var v = Object.getOwnPropertySymbols;
var R = Object.prototype.hasOwnProperty, H = Object.prototype.propertyIsEnumerable;
var G = (n, s, i) => s in n ? oe(n, s, { enumerable: !0, configurable: !0, writable: !0, value: i }) : n[s] = i, O = (n, s) => {
  for (var i in s || (s = {}))
    R.call(s, i) && G(n, i, s[i]);
  if (v)
    for (var i of v(s))
      H.call(s, i) && G(n, i, s[i]);
  return n;
}, j = (n, s) => le(n, te(s));
var V = (n, s) => {
  var i = {};
  for (var c in n)
    R.call(n, c) && s.indexOf(c) < 0 && (i[c] = n[c]);
  if (n != null && v)
    for (var c of v(n))
      s.indexOf(c) < 0 && H.call(n, c) && (i[c] = n[c]);
  return i;
};
import { jsx as t, jsxs as S, Fragment as ne } from "react/jsx-runtime";
import { useState as re, useRef as se, useMemo as x, useCallback as ie } from "react";
import { Button as ce } from "../Button/index.js";
import { ErrorMessage as ae } from "../../molecules/ErrorMessage/index.js";
import { ComboboxChevron as pe } from "../../icons/ComboboxChevron.js";
import { Checkbox as D } from "../Checkbox/index.js";
import { Label as ue } from "../Label/index.js";
import { XMarkFarFAIcon as de, CircleExclamationFarFAIcon as he } from "../Icons/index.js";
import { Stack as fe } from "../Stack/index.js";
import { Text as be } from "../Text/index.js";
import { DismissibleTag as me } from "../DismissibleTag/index.js";
import { ProgressIndicator as W } from "../ProgressIndicator/index.js";
import { g as ge, a as ye, u as _e, C as h } from "../../Combobox-CmRRrGfX.js";
import { u as ve } from "../../use-uncontrolled-BT_j5D2R.js";
import { P as I } from "../../PillsInput-yGVpK8NH.js";
import { P as Oe } from "../../Pill-s4XaUkmY.js";
import { I as Se } from "../../Input--FNE961U.js";
import { F as we } from "../../Flex-BcSdq2bJ.js";
import { G as P } from "../../Group-CbE78j-X.js";
const Ce = "MultiSelect-module__pillsInput___Ysa7c", ke = "MultiSelect-module__pill___E-PVY", xe = "MultiSelect-module__options___1-W33", De = "MultiSelect-module__option___IT-Wc", Ie = "MultiSelect-module__clearSelectionButton___o3rbJ", Pe = "MultiSelect-module__emptyState___b9Gpy", b = {
  pillsInput: Ce,
  pill: ke,
  options: xe,
  option: De,
  clearSelectionButton: Ie,
  emptyState: Pe
}, qe = (Fe) => {
  var N = Fe, {
    defaultValue: n,
    description: s,
    disabled: i,
    error: c,
    data: p,
    label: B,
    placeholder: F,
    onChange: K,
    value: Y,
    required: y,
    className: J,
    width: U,
    variant: u = "default",
    searchPlaceholder: Be = "Search...",
    onLoadMore: _,
    onSearch: w,
    loading: M
  } = N, X = V(N, [
    "defaultValue",
    "description",
    "disabled",
    "error",
    "data",
    "label",
    "placeholder",
    "onChange",
    "value",
    "required",
    "className",
    "width",
    "variant",
    "searchPlaceholder",
    "onLoadMore",
    "onSearch",
    "loading"
  ]);
  const [d, Q] = re(""), m = !!_, T = se({}), A = (e) => {
    u === "searchable" && (w == null || w(e), Q(e));
  }, g = x(() => ge(p), [p]), Z = x(() => u !== "searchable" || !d || m ? g : g.filter(
    (e) => {
      var l;
      return (l = e == null ? void 0 : e.label) == null ? void 0 : l.toLowerCase().includes(d.toLowerCase());
    }
  ), [g, d, u]), z = x(() => {
    const e = ye(g);
    return m && Object.assign(T.current, e), m ? O(O({}, T.current), e) : e;
  }, [g, m]), a = _e({
    onDropdownClose: () => {
      a.resetSelectedOption(), u === "searchable" && A("");
    },
    onDropdownOpen: (e) => {
      e === "keyboard" ? a.selectActiveOption() : a.updateSelectedOptionIndex("active");
    }
  }), [r, C] = ve({
    value: Y,
    defaultValue: n || [],
    onChange: K
  }), $ = (e) => {
    const l = z[e];
    C(
      r.includes(e) ? r.filter((f) => f !== e) : [...r, e],
      l
    );
  }, k = (e) => C(r.filter((l) => l !== e)), q = ie((e) => {
    if (!_) return;
    const l = e.currentTarget, f = l.scrollTop, o = l.scrollHeight, E = l.clientHeight;
    o - f - E < 10 && _(p == null ? void 0 : p.length);
  }, [_]), ee = r.map((e) => /* @__PURE__ */ t(me, { withRemoveButton: !0, onRemove: () => k(e), className: b.pill, children: z[e].label }, e)), L = (() => {
    if (!p || p.length === 0) return [];
    if (!Array.isArray(p) || p.every((l) => typeof l == "string" || !("group" in l)))
      return Z.map((l, f) => /* @__PURE__ */ t(
        h.Option,
        {
          active: r.includes(l.value),
          value: l.value,
          onMouseOver: () => a.selectOption(f),
          className: b.option,
          disabled: l.disabled,
          children: /* @__PURE__ */ t(P, { gap: "sm", children: /* @__PURE__ */ t(
            D,
            {
              checked: r.includes(l.value),
              label: l.label,
              disabled: l.disabled,
              readOnly: !0,
              required: y
            }
          ) })
        },
        l.value
      ));
    let e = 0;
    return p.map((l) => {
      if (typeof l == "string" || !("group" in l)) {
        const o = typeof l == "string" ? { label: l, value: l } : l;
        return u !== "searchable" || !d || o.label.toLowerCase().includes(d.toLowerCase()) ? /* @__PURE__ */ t(
          h.Option,
          {
            active: r.includes(o.value),
            value: o.value,
            onMouseOver: () => a.selectOption(e++),
            className: b.option,
            disabled: o.disabled,
            children: /* @__PURE__ */ t(P, { gap: "sm", children: /* @__PURE__ */ t(
              D,
              {
                checked: r.includes(o.value),
                label: o.label,
                disabled: o.disabled,
                readOnly: !0,
                required: y
              }
            ) })
          },
          o.value
        ) : null;
      }
      const f = l.items.filter(
        (o) => u !== "searchable" || !d || (typeof o == "string" ? o : o.label).toLowerCase().includes(d.toLowerCase())
      );
      return f.length === 0 ? null : /* @__PURE__ */ t(h.Group, { label: l.group, children: f.map((o) => /* @__PURE__ */ t(
        h.Option,
        {
          active: r.includes(typeof o == "string" ? o : o.value),
          value: typeof o == "string" ? o : o.value,
          onMouseOver: () => a.selectOption(e++),
          className: b.option,
          disabled: typeof o == "string" ? !1 : o.disabled,
          children: /* @__PURE__ */ t(P, { gap: "sm", children: /* @__PURE__ */ t(
            D,
            {
              checked: r.includes(typeof o == "string" ? o : o.value),
              label: typeof o == "string" ? o : o.label,
              disabled: typeof o == "string" ? !1 : o.disabled,
              readOnly: !0,
              required: y
            }
          ) })
        },
        typeof o == "string" ? o : o.value
      )) }, l.group);
    }).filter(Boolean);
  })();
  return /* @__PURE__ */ S(h, { store: a, onOptionSubmit: $, withinPortal: !1, disabled: i, children: [
    /* @__PURE__ */ t(h.DropdownTarget, { children: /* @__PURE__ */ S(
      I,
      j(O({
        disabled: i,
        pointer: !0,
        "data-expanded": a.dropdownOpened || void 0,
        rightSection: M ? /* @__PURE__ */ t(W, { size: "xs" }) : /* @__PURE__ */ t(pe, { size: "xs", error: c }),
        rightSectionPointerEvents: "none",
        classNames: { input: b.pillsInput },
        label: /* @__PURE__ */ t(ue, { label: B, withAsterisk: y }),
        description: s,
        descriptionProps: { c: "gray.8" },
        error: c && /* @__PURE__ */ t(ae, { error: c }),
        inputWrapperOrder: ["label", "input", c ? "error" : "description"],
        className: J,
        style: { width: U },
        onClick: u === "default" ? () => a.toggleDropdown() : void 0
      }, X), {
        children: [
          /* @__PURE__ */ S(Oe.Group, { role: "group", "aria-label": "Selected options", children: [
            r.length > 0 ? ee : u !== "searchable" ? /* @__PURE__ */ t(Se.Placeholder, { children: F }) : null,
            /* @__PURE__ */ t(h.EventsTarget, { children: u === "searchable" ? /* @__PURE__ */ t(
              I.Field,
              {
                value: d,
                placeholder: r.length === 0 ? F : void 0,
                onChange: (e) => {
                  A(e.currentTarget.value), a.dropdownOpened || a.openDropdown(), a.updateSelectedOptionIndex();
                },
                onFocus: () => a.openDropdown(),
                onBlur: () => a.closeDropdown(),
                onKeyDown: (e) => {
                  e.key === "Backspace" && d.length === 0 && (e.preventDefault(), k(r[r.length - 1]));
                },
                autoComplete: "off"
              }
            ) : /* @__PURE__ */ t(
              I.Field,
              {
                readOnly: !0,
                onKeyDown: (e) => {
                  e.key === "Backspace" && (e.preventDefault(), k(r[r.length - 1]));
                }
              }
            ) })
          ] }),
          r.length > 0 && /* @__PURE__ */ t(we, { align: "center", children: /* @__PURE__ */ t(
            ce,
            {
              variant: "tertiary",
              size: "sm",
              onClick: (e) => {
                e.stopPropagation(), C([]);
              },
              "aria-label": "Clear selection",
              className: b.clearSelectionButton,
              children: /* @__PURE__ */ t(de, {})
            }
          ) })
        ]
      })
    ) }),
    /* @__PURE__ */ t(h.Dropdown, { children: /* @__PURE__ */ t(
      h.Options,
      {
        "aria-label": B,
        className: b.options,
        onScroll: m ? q : void 0,
        children: L.length > 0 ? L : u === "searchable" && d ? /* @__PURE__ */ t(fe, { className: b.emptyState, children: M ? /* @__PURE__ */ t(W, { size: "md" }) : /* @__PURE__ */ S(ne, { children: [
          /* @__PURE__ */ t(he, { size: 24 }),
          /* @__PURE__ */ t(be, { size: "md", prominent: !0, c: "gray.7", children: "No results found" })
        ] }) }) : null
      }
    ) })
  ] });
};
export {
  qe as MultiSelect
};
